export const GET_NEGOTIATION = 'sagas/payment/GET_NEGOTIATION'
export const CREATE_AND_FILL_NEGOTIATION = 'sagas/payment/CREATE_AND_FILL_NEGOTIATION'
export const GET_TASKS_ATTRIBUTES = 'sagas/payment/GET_TASKS_ATTRIBUTES'
